import { ContentContext, LocaleContext, RegionContext } from 'Components/hooks/context';
import React, { useContext, useEffect, useState } from 'react';

import SmartText from './SmartText';
import StackedAreaChart from '@reuters-graphics/chart-module-stacked-area-chart';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import debounce from 'lodash/debounce';

const areaChart = new StackedAreaChart();

const areaChartContainer = React.createRef();

const fills = ['#63686F', '#63686F', '#63686F', '#63686F', '#63686F', '#63686F'];

const resize = debounce(() => {
  areaChart.draw();
}, 250);

const RegionShare = ({ counts, endDates }) => {
  const { cases, deaths } = counts;

  const locale = useContext(LocaleContext);
  const region = useContext(RegionContext);
  const content = useContext(ContentContext).template.byRegion;

  const [showAbsolute, setShowAbsolute] = useState(true);
  const [activeData, setActiveData] = useState('cases');
  const optionsText = content.showBy.split(' ');

  useEffect(() => {
    areaChart
      .selection(areaChartContainer.current)
      .data(counts[activeData])
      .props({
        locale,
        absolute: showAbsolute,
        margin: { left: 8, right: 42, top: 10, bottom: 20 },
        stroke: '#63686F',
        stroke_width: 1,
        fills,
        highlight_variable: region,
        highlight_color: '#fce587',
        hide_key: true,
        range: {
          start_date: '2020-02-02',
          end_date: endDates[activeData],
        },
        chart_formats: {
          // Format if number
          number: '~s',

          // Format if percent
          percent: '.0%',

          // Date format for the x axis
          date: '%b',
        },
      })
      .draw();
  }, [counts, cases, deaths, locale, showAbsolute, activeData, region, endDates]);

  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  return (
    <div className={classnames(component)}>
      <div className='section-spacer' />
      <div className='section-spacer-internal' />
      <div>
        <h2>{content.title}</h2>
        <SmartText cases={cases} locale={locale} region={region} />
        <div className='section-spacer-internal' />
        <div className='options font-sans'>
          <span>{optionsText[0]}</span>
          <div className='options-group'>
            <button
              className={classnames({ active: activeData === 'cases' })}
              onClick={() => setActiveData('cases')}
            >
              {content.showByCases}
            </button>
            <button
              className={classnames({ active: activeData === 'deaths' })}
              onClick={() => setActiveData('deaths')}
            >
              {content.showByDeaths}
            </button>
          </div>
          <div className='section-spacer-internal' />
          <span>{optionsText[1]}</span>
          <div className='options-group'>
            <button
              className={classnames({ active: showAbsolute })}
              onClick={() => setShowAbsolute(true)}
            >
              {content.showByCount}
            </button>
            <button
              className={classnames({ active: !showAbsolute })}
              onClick={() => setShowAbsolute(false)}
            >
              {content.showByPercent}
            </button>
          </div>
        </div>
        <div
          className={classnames(
            'stacked-area-chart-container font-sans',
            { absolute: showAbsolute }
          )} ref={areaChartContainer}
        />
        <p className='small'>*{content.note}</p>
      </div>
      <div className='section-spacer after' />
      <div className='section-spacer-internal after' />
    </div>
  );
};

export default RegionShare;
